import { namedRoutes } from '@confluence/named-routes';
import { Route } from '@confluence/route';

/**
 * Converts URLs like:
 *   `https://hello.atlassian.net/wiki/spaces/C4L/pages/2529838556/CES+Confluence+Cloud+Support+Team`
 * to:
 *   `https://hello.atlassian.net/VIEW_PAGE`
 *
 * See:
 *   https://atlassian.slack.com/archives/C05UTMPCRV4/p1711577710717029?thread_ts=1710965978.690009&cid=C05UTMPCRV4
 */
export const redactUgcFromUrl = (url: string) => {
	// If this function throws, it'll get called twice a second, so be sure to
	// catch exceptions
	try {
		const parts = new URL(url);
		const { pathname } = parts;

		// There might be useful navigation in the query string (like a selected
		// tab), but there might be UGC in there instead (like an attachment
		// filename). Take no chances and scrub it all. If you need something in the
		// query parameter for some page, add manual instrumentation.
		parts.search = '';

		// The `.hash` (fragment) is almost certainly all UGC
		parts.hash = '';

		// These shouldn't be used, but let's be certain we don't capture them
		parts.username = '';
		parts.password = '';

		// `.hostname`, `.protocol` and `.port` we'll allow through as-is

		// Find a matching route. If one exists, substitute the whole path for
		// the route's name.
		const match = Route.matchFirst(Object.values(namedRoutes), pathname);
		if (match) {
			parts.pathname = match.name;
		}
		// ...and if it doesn't exist (perhaps Confluence was embedded within a JSM
		// page), all we can say is that we don't know.
		else {
			parts.pathname = 'NO_MATCH';
		}

		return parts.toString();
	} catch (e) {
		return 'EXCEPTION';
	}
};
